<template lang="pug">
  multiselect(class="multiselect-default"
              :searchable="false"
              :options="options"
              :show-labels="false"
              :placeholder="placeholder"
              :name="name")
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true
    },
    placeholder: {
      type: String,
      default: "Séléctionnez une option"
    },
    name: {
      type: String,
      default: "contact"
    }
  }

}
</script>
